import React, { useEffect, useState } from "react";
import "./ColorPalette.css";
import { BASE_URL } from "../../../constant";

const ColorPalette = ({ setActiveColor }) => {
  const [colors, setColors] = useState([]);

  const handleClick = (color) => {
    setActiveColor(color);
  };

  useEffect(() => {
    fetch(`${BASE_URL}/api/customProducts/all-colors`)
      .then((response) => response.json())
      .then((data) => {
        setColors(data);
      })
      .catch((error) => console.error("Error fetching colors:", error));
  }, []);

  return (
    <div className="color-palette">
      <h1 className="title">EXPLORE YOUR FAVOURITE COLOURS</h1>
      <div className="color-buttons">
        {colors
          .filter((item) => {
            return item && !item.includes("-") && item.trim() !== "";
          })
          .slice(0, 5)
          .map((color) => (
            <div key={color} className="color-item">
              <button
                onClick={() => handleClick(color)}
                className="color-button"
                style={{
                  backgroundColor: color == "FEEROJU" ? "#6abce2" : color,
                }}
                aria-label={`Select ${color}`}
              />
              <span className="color-name">{color}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ColorPalette;
